import { Helmet } from 'react-helmet-async';
import { useLanguage } from '../../context/LanguageContext/LanguageContext';
import { usePageView } from '../../hooks/usePageView';

import cert1 from './cert-1.png';
import cert2 from './cert-2.png';
import cert3 from './cert-3.png';
import cert4 from './cert-4.png';
import cert5 from './cert-5.png';
import cert6 from './cert-6.png';
import cert1w from './cert-1.webp';
import cert2w from './cert-2.webp';
import cert3w from './cert-3.webp';
import cert4w from './cert-4.webp';
import cert5w from './cert-5.webp';
import cert6w from './cert-6.webp';

import honor1 from './honor-1.jpg';
import honor2 from './honor-2.jpg';
import honor3 from './honor-3.jpg';
import honor4 from './honor-4.jpg';
import honor5 from './honor-5.jpg';
import honor6 from './honor-6.jpg';
import honor7 from './honor-7.jpg';
import honor8 from './honor-8.jpg';
import honor9 from './honor-9.jpg';
import honor1w from './honor-1.webp';
import honor2w from './honor-2.webp';
import honor3w from './honor-3.webp';
import honor4w from './honor-4.webp';
import honor5w from './honor-5.webp';
import honor6w from './honor-6.webp';
import honor7w from './honor-7.webp';
import honor8w from './honor-8.webp';
import honor9w from './honor-9.webp';

import airline0 from './airline-0.png';
import airline1 from './airline-1.png';
import airline2 from './airline-2.png';
import airline3 from './airline-3.png';
import airline4 from './airline-4.png';
import airline5 from './airline-5.png';
import airline6 from './airline-6.png';
import airline7 from './airline-7.png';
import airline8 from './airline-8.png';
import airline9 from './airline-9.png';
import airline10 from './airline-10.png';
import airline11 from './airline-11.png';
import airline0w from './airline-0.webp';
import airline1w from './airline-1.webp';
import airline2w from './airline-2.webp';
import airline3w from './airline-3.webp';
import airline4w from './airline-4.webp';
import airline5w from './airline-5.webp';
import airline6w from './airline-6.webp';
import airline7w from './airline-7.webp';
import airline8w from './airline-8.webp';
import airline9w from './airline-9.webp';
import airline10w from './airline-10.webp';
import airline11w from './airline-11.webp';

import customer1 from './customer-1.png';
import customer2 from './customer-2.png';
import customer3 from './customer-3.png';
import customer4 from './customer-4.png';
import customer5 from './customer-5.png';
import customer6 from './customer-6.png';
import customer7 from './customer-7.png';
import customer1w from './customer-1.webp';
import customer2w from './customer-2.webp';
import customer3w from './customer-3.webp';
import customer4w from './customer-4.webp';
import customer5w from './customer-5.webp';
import customer6w from './customer-6.webp';
import customer7w from './customer-7.webp';

import assoc1 from './assoc-1.png';
import assoc2 from './assoc-2.png';
import assoc3 from './assoc-3.png';
import assoc4 from './assoc-4.png';
import assoc5 from './assoc-5.jpg';
import assoc6 from './assoc-6.jpg';
import assoc7 from './assoc-7.jpg';
import assoc1w from './assoc-1.webp';
import assoc2w from './assoc-2.webp';
import assoc3w from './assoc-3.webp';
import assoc4w from './assoc-4.webp';
import assoc5w from './assoc-5.webp';
import assoc6w from './assoc-6.webp';
import assoc7w from './assoc-7.webp';

import './Credentials.css';

const CERTS = [
  { src: cert1, webp: cert1w },
  { src: cert2, webp: cert2w },
  { src: cert3, webp: cert3w },
  { src: cert4, webp: cert4w },
  { src: cert5, webp: cert5w },
  { src: cert6, webp: cert6w },
];

const HONORS = [
  { src: honor1, webp: honor1w },
  { src: honor2, webp: honor2w },
  { src: honor3, webp: honor3w },
  { src: honor4, webp: honor4w },
  { src: honor5, webp: honor5w },
  { src: honor6, webp: honor6w },
  { src: honor7, webp: honor7w },
  { src: honor8, webp: honor8w },
  { src: honor9, webp: honor9w },
];

const AIRLINES = [
  { src: airline0, webp: airline0w },
  { src: airline1, webp: airline1w },
  { src: airline2, webp: airline2w },
  { src: airline3, webp: airline3w },
  { src: airline4, webp: airline4w },
  { src: airline5, webp: airline5w },
  { src: airline6, webp: airline6w },
  { src: airline7, webp: airline7w },
  { src: airline8, webp: airline8w },
  { src: airline9, webp: airline9w },
  { src: airline10, webp: airline10w },
  { src: airline11, webp: airline11w },
];

const CUSTOMERS = [
  { src: customer1, webp: customer1w },
  { src: customer2, webp: customer2w },
  { src: customer3, webp: customer3w },
  { src: customer4, webp: customer4w },
  { src: customer5, webp: customer5w },
  { src: customer6, webp: customer6w },
  { src: customer7, webp: customer7w },
];

const ASSOCS = [
  { src: assoc1, webp: assoc1w },
  { src: assoc2, webp: assoc2w },
  { src: assoc3, webp: assoc3w },
  { src: assoc4, webp: assoc4w },
  { src: assoc5, webp: assoc5w },
  { src: assoc6, webp: assoc6w },
  { src: assoc7, webp: assoc7w },
];

function Credentials() {
  usePageView('credentials');
  const { t } = useLanguage();
  const c = t.credentials;

  return (
    <div className="credentials-page">
      <Helmet>
        <title>{c.pageTitle} - 首嘉/深圳瀚阳</title>
        <meta name="description" content={c.pageSubtitle} />
        <link rel="canonical" href="https://www.sz-showjoy.com/credentials" />
      </Helmet>

      <div className="page-header">
        <div className="container">
          <h1>{c.pageTitle}</h1>
          <p>{c.pageSubtitle}</p>
        </div>
      </div>

      <section className="section">
        <div className="container">
          <h2 className="section-title">{c.certsTitle}</h2>
          <p className="section-subtitle">{c.certsSubtitle}</p>
          <div className="credentials-grid">
            {CERTS.map((img, i) => (
              <div className="credential-item" key={i}>
                <picture>
                  <source srcSet={img.webp} type="image/webp" />
                  <img src={img.src} alt={`${c.certsTitle} ${i + 1}`} loading="lazy" />
                </picture>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section" style={{ background: '#f8f9fa' }}>
        <div className="container">
          <h2 className="section-title">{c.honorTitle}</h2>
          <p className="section-subtitle">{c.honorSubtitle}</p>
          <div className="credentials-grid">
            {HONORS.map((img, i) => (
              <div className="credential-item" key={i}>
                <picture>
                  <source srcSet={img.webp} type="image/webp" />
                  <img src={img.src} alt={`${c.honorTitle} ${i + 1}`} loading="lazy" />
                </picture>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <h2 className="section-title">{c.airlinesTitle}</h2>
          <p className="section-subtitle">{c.airlinesSubtitle}</p>
          <div className="logo-grid">
            {AIRLINES.map((img, i) => (
              <div className="logo-item" key={i}>
                <picture>
                  <source srcSet={img.webp} type="image/webp" />
                  <img src={img.src} alt={`${c.airlinesTitle} ${i + 1}`} loading="lazy" />
                </picture>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section" style={{ background: '#f8f9fa' }}>
        <div className="container">
          <h2 className="section-title">{c.customersTitle}</h2>
          <p className="section-subtitle">{c.customersSubtitle}</p>
          <div className="logo-grid">
            {CUSTOMERS.map((img, i) => (
              <div className="logo-item" key={i}>
                <picture>
                  <source srcSet={img.webp} type="image/webp" />
                  <img src={img.src} alt={`${c.customersTitle} ${i + 1}`} loading="lazy" />
                </picture>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <h2 className="section-title">{c.assocTitle}</h2>
          <p className="section-subtitle">{c.assocSubtitle}</p>
          <div className="logo-grid">
            {ASSOCS.map((img, i) => (
              <div className="logo-item" key={i}>
                <picture>
                  <source srcSet={img.webp} type="image/webp" />
                  <img src={img.src} alt={`${c.assocTitle} ${i + 1}`} loading="lazy" />
                </picture>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Credentials;
